import api from "./api";
import TokenService from "./token.service";
import { config } from "./config.service";

const API_URL = config.host_api;

const handleResponseError = (error) => {
  if (error?.response?.data?.error) {
    throw error.response.data.error;
  }
  throw error;
};

const login = async (email, password) => {
  return api
    .post(API_URL + "login", { email, password })
    .then((res) => {
      if (res.data.accessToken) {
        TokenService.setUser(res.data);
      }
      return res.data;
    })
    .catch((err) => handleResponseError(err));
};

const register = async (formData) => {
  return api.post(API_URL + "register", formData);
};

const logout = () => {
  // localStorage.removeItem("user");
  TokenService.removeUser();
};

const AuthService = {
  register,
  login,
  logout
};

export default AuthService;
